import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../apiBase';
import './profile-account.css';

function authApi() {
    return axios.create({
        baseURL: getApiBaseUrl(),
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    });
}

export default function ChangePasswordSection() {
    const { t } = useTranslation('profile');
    const [form, setForm] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setSuccess(false);

        if (form.newPassword !== form.confirmPassword) {
            setError(t('passwordsDontMatch'));
            return;
        }
        if (form.newPassword.length < 8) {
            setError(t('passwordTooShort'));
            return;
        }

        setLoading(true);
        try {
            await authApi().post('/auth/change-password', {
                currentPassword: form.currentPassword,
                newPassword: form.newPassword,
                confirmPassword: form.confirmPassword,
            });
            setSuccess(true);
            setForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
        } catch (err) {
            setError(err.response?.data?.message || t('error'));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="sp-panel profile-account__section">
            <h3 className="profile-account__title">🔐 {t('changePassword')}</h3>

            {success && (
                <div className="profile-account__alert profile-account__alert--success">
                    ✅ {t('passwordChanged')}
                </div>
            )}

            {error && (
                <div className="profile-account__alert profile-account__alert--error">{error}</div>
            )}

            <form onSubmit={handleSubmit} className="profile-account__form">
                <input
                    className="sp-input"
                    type="password"
                    placeholder={t('currentPassword')}
                    value={form.currentPassword}
                    onChange={(e) => setForm({ ...form, currentPassword: e.target.value })}
                    required
                    autoComplete="current-password"
                />
                <input
                    className="sp-input"
                    type="password"
                    placeholder={t('newPassword')}
                    value={form.newPassword}
                    onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
                    required
                    minLength={8}
                    autoComplete="new-password"
                />
                <input
                    className="sp-input"
                    type="password"
                    placeholder={t('confirmNewPassword')}
                    value={form.confirmPassword}
                    onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                    required
                    autoComplete="new-password"
                />
                <button type="submit" className="sp-btn sp-btn--primary" disabled={loading}>
                    {loading ? t('saving') : t('changePassword')}
                </button>
            </form>
        </div>
    );
}
